<template>
  <div>
    <b-alert v-if="!contributionClosed" class="mt-5" style="text-align:center" variant="info" show>The Contributions
      date has either passed and no more contributions can be
      made to this event as the limit has been met</b-alert>
    <section v-else-if="contributionClosed && !paymentSuccess" class="row" style="margin-left:1px;margin-right:1px;">
      <b-col sm="12">
        <b-row>
          <b-col sm="12">
            <h1 class="section-heading">Make a Contribution</h1>
          </b-col>
        </b-row>
        <section class="row" style="margin-left:1px;margin-right:1px;">
          <div class="col-md-12 col-md-offset-1">
            <!-- form -->
            <b-form id="apptForm" @submit="onSubmit">
              <!-- Person 1 First Name -->
              <b-row class="pb-3">
                <div class="col-3">
                  <label for="FirstName">Cardholders First Name<span class="required">*</span></label>
                </div>
                <div class="col-3">
                  <div class="select-holder">
                    <b-form-select class="form-select" v-model.trim="title" id="title-input-1" name="title-input-1"
                      :options="titleOptions" :state="validateState('title')" @change="touchField($v.title)">
                    </b-form-select>
                    <div class="alert alert-danger m-b-0" v-if="$v.title.$dirty && !$v.title.required">
                      Please select a title.
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <b-form-input v-model.trim="firstname" id="example-input-1" style=" border-radius:5px"
                    placeholder="Firstname" :state="validateState('firstname')" @change="touchField($v.firstname)">
                  </b-form-input>
                  <div class="alert alert-danger m-b-0" v-if="$v.firstname.$dirty && !$v.firstname.required">
                    Field is required
                  </div>
                </div>
              </b-row>

              <!-- Person 1 Last Name -->
              <b-row class="pb-3">
                <div class="col-3">
                  <label for="LastName">Cardholders Last Name<span class="required">*</span></label>
                </div>
                <div class="col-9">
                  <b-form-input v-model.trim="surname" id="example-input-1" style=" border-radius:5px"
                    placeholder="Lastname" :state="validateState('surname')" @change="touchField($v.surname)">
                  </b-form-input>
                  <div class="alert alert-danger m-b-0" v-if="$v.surname.$dirty && !$v.surname.required">
                    Field is required
                  </div>
                </div>
              </b-row>

              <b-row class="pb-3">
                <div class="col-3">
                  <label for="ContactNumber">Contact Number <span class="required">*</span></label>
                </div>
                <div class="col-9">
                  <b-form-input type="tel" placeholder="Contact Telephone Number" v-model.trim="number"
                    :state="validateState('number')" @change="touchField($v.number)"></b-form-input>
                  <div class="alert alert-danger m-b-0" v-if="$v.number.$dirty && !$v.number.required">
                    Field is required
                  </div>
                  <!-- <div class="alert alert-danger m-b-0" v-if="!$v.number.numeric || !$v.number.minLength">Must be a valid number</div> -->
                </div>
              </b-row>

              <b-row class="pb-3">
                <div class="col-3">
                  <label for="Email">Email Address<span class="required">*</span></label>
                </div>
                <div class="col-9">
                  <b-form-input type="email" placeholder="Email Address" v-model.trim="email"
                    :state="validateState('email')" @change="touchField($v.email)"></b-form-input>
                  <div class="alert alert-danger mb-0" v-if="$v.email.$dirty && !$v.email.required">
                    Field is required
                  </div>
                  <div class="alert alert-danger mb-0" v-if="!$v.email.email || !$v.email.minLength">
                    Must be a valid e-mail
                    <small>e.g. example@example.com (Must contain lowercase)</small>
                  </div>
                </div>
              </b-row>

              <hr />
              <h3 class="text-center mb-5">Your Contribution</h3>

              <b-row class="pb-3">
                <div class="col-3">
                  <label for="Amount">Amount<span class="required">* <span v-if="!isIe">(£)</span><span
                        v-if="isIe">(€)</span></span></label>
                </div>
                <div class="col-sm-9">
                  <b-form-input placeholder="Contribution Amount" v-model.trim="amount" :state="validateState('amount')"
                    @keypress="isNumber($event)" @change="touchField($v.amount)"></b-form-input>
                  <div class="alert alert-danger mb-0"
                    v-if="$v.amount.$dirty && !$v.amount.required || $v.amount.$dirty && !$v.amount.numeric">
                    Field is required (Currency Symbol NOT allowed e.g. £/€)
                  </div>
                </div>
              </b-row>

              <b-row class="pb-3">
                <div class="col-3">
                  <label for="Message">Your Message <span class="required">*</span></label>
                </div>
                <div class="col-9">
                  <b-form-textarea :state="validateState('message')" @change="touchField($v.message)" rows="6"
                    style="border-radius:5px; margin-top:8px" id="input-7" placeholder="Message from you"
                    v-model="message">
                  </b-form-textarea>
                  <div class="alert alert-danger mb-0" v-if="$v.message.$dirty && !$v.message.required">
                    Field is required
                  </div>
                </div>
              </b-row>
              <!-- International Payment Option -->
              <b-row class="pb-3">
                <div class="col-3">
                  <label>International Address</label>
                </div>
                <div class="col-sm-9 ">
                  <div role="alert">
                    <b-col style="padding-left:0px; padding-right:0px;" sm="12">
                      <b-form-checkbox id="intAddress" v-model.trim="intAddress" name="intAddress" value="yes"
                        unchecked-value="''" size="sm" class="float-start">
                        Tick here if your address is outside of {{ site }}
                      </b-form-checkbox>
                    </b-col>
                  </div>
                </div>
              </b-row>
              <!-- County Code -->
              <b-row class="pb-3" v-if="intAddress === 'yes'">
                <div class="col-3">
                  <label for="countryCode">Country<span class="required">*</span></label>
                </div>
                <div class="col-9">
                  <div class="select-holder">
                    <b-form-select v-model.trim="countryCode" id="countryCode" class="form-select" name="countryCode"
                      :options="countryCodes" :state="validateState('countryCode')"
                      @change="touchField($v.countryCode)">
                    </b-form-select>
                    <div class="alert alert-danger mb-0" v-if="$v.countryCode.$dirty && !$v.countryCode.required">
                      Please select a Country.
                    </div>
                  </div>
                </div>
              </b-row>

              <!-- Address Info -->
              <b-row v-if="intAddress !== 'yes'">
                <b-col sm="12">
                  <div class="form-group">
                    <b-row>
                      <b-col sm="3">
                        <label for="postcode">Postal Address<span class="required">*</span></label>
                      </b-col>
                      <b-col sm="9">
                        <Autoaddress v-if="isIe" licencekey="2e9c9e91-eda5-472e-ae24-7d3569bec687" vanityMode="true"
                          addressProfile="Demo5LineV2" country="ie" language="en"
                          noResultFoundLabel="No search results have been found.Please enter address manually below."
                          @onAddressFound="foundAddress($event)" />
                        <div v-if="!isIe" class="post-code-input">
                          <b-form-input class="form-control-contact sm-9" v-model.trim="postcodeSearch"
                            @input="postcodeLookup" type="text" id="post-code" placeholder="Enter Postcode" />

                          <div class="post-code-results" v-if="postcodeDropdown">
                            <ul>
                              <li @click="handleSelection(address.suggestion)"
                                v-for="(address, index) in postcodeResult" :key="index">
                                {{ address.suggestion }}
                              </li>
                            </ul>
                          </div>
                          <p class="ps-2">
                            or enter address manually below ...
                          </p>
                        </div>
                      </b-col>
                    </b-row>
                  </div>
                </b-col>
              </b-row>

              <b-row v-if="addressFound || intAddress === 'yes'">
                <div class="col-12">
                  <div class="form-group">
                    <div class="row">
                      <div class="col-3">
                        <label for="address1">Address 1 <span class="required">*</span></label>
                      </div>
                      <div class="col-9">
                        <b-form-input v-model.trim="addressLine1" placeholder="Address Line 1"
                          :state="validateState('addressLine1')" @change="touchField($v.addressLine1)"></b-form-input>
                        <div class="alert alert-danger mb-0" v-if="
                          $v.addressLine1.$dirty && !$v.addressLine1.required
                        ">
                          Field is required
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group">
                    <div class="row">
                      <div class="col-3">
                        <label for="address2">Address 2 <span class="required">*</span></label>
                      </div>
                      <div class="col-9">
                        <b-form-input v-model.trim="addressLine2" placeholder="Address Line 2"
                          :state="validateState('addressLine2')" @change="touchField($v.addressLine2)"></b-form-input>
                        <div class="alert alert-danger mb-0" v-if="
                          $v.addressLine2.$dirty && !$v.addressLine2.required
                        ">
                          Field is required
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group">
                    <div class="row">
                      <div class="col-3">
                        <label for="address3">Address 3</label>
                      </div>
                      <div class="col-9">
                        <b-form-input v-model.trim="addressLine3" placeholder="Address Line 3"></b-form-input>
                      </div>
                    </div>
                  </div>

                  <div class="form-group" v-if="!isIe">
                    <div class="row">
                      <div class="col-3">
                        <label v-if="isAddressUk === 'No'" for="postcode">Postal Code / Zip Code<span
                            class="required">*</span></label>
                        <label v-else for="postcode">Postcode<span class="required">*</span></label>
                      </div>
                      <div class="col-9">
                        <b-form-input v-if="isAddressUk === 'No'" v-model.trim="postCode"
                          placeholder="Postal Code / Zip Code" :state="validateState('postCode')"
                          @change="touchField($v.postCode)"></b-form-input>
                        <b-form-input v-else v-model.trim="postCode" placeholder="Postcode"
                          :state="validateState('postCode')" @change="touchField($v.postCode)"></b-form-input>
                        <div class="alert alert-danger mb-0" v-if="$v.postCode.$dirty && !$v.postCode.required">
                          Field is required
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group" v-if="isIe">
                    <div class="row">
                      <div class="col-3">
                        <label v-if="isAddressIe === 'No'" for="postcode">Postal Code / Zip Code<span
                            class="required">*</span></label>
                        <label v-else for="postcode">Eircode<span class="required">*</span></label>
                      </div>
                      <div class="col-9">
                        <b-form-input v-if="isAddressIe === 'No'" v-model.trim="eircode"
                          placeholder="Postal Code / Zip Code" :state="validateState('eircode')"
                          @change="touchField($v.eircode)"></b-form-input>
                        <b-form-input v-else placeholder="Eircode" v-model.trim="eircode"
                          :state="validateState('eircode')" @change="touchField($v.eircode)"></b-form-input>
                      </div>
                    </div>
                  </div>
                </div>
              </b-row>

              <!-- Email Alert -->
              <b-row>
                <div class="col-sm-12">
                  <hr class="d-block d-md-none" />
                </div>

                <div class="col-3">
                  <label>Email Alert</label>
                </div>
                <div class="col-9 ">
                  <div role="alert">
                    <b-col style="padding-left:0px; padding-right:0px;" sm="12">
                      <b-form-checkbox id="tfEmails" v-model.trim="tfEmails" name="tfEmails" value="yes"
                        unchecked-value="''" size="sm" class="float-start d-inline">
                        Tick here to sign up for Trailfinders special offers and travel articles
                      </b-form-checkbox>
                    </b-col>

                    <b-col style="padding-left:0px; padding-right:0px;" sm="12">
                      <b-form-checkbox id="tfMagazines" v-model.trim="tfMagazines" name="tfMagazines" value="yes"
                        unchecked-value="''" size="sm" class="float-start">
                        Tick here to receive the Trailfinder Magazine, published three times a year
                      </b-form-checkbox>
                    </b-col>
                  </div>
                </div>
              </b-row>

              <b-row>
                <b-col sm="12">
                  <div class="form-group">
                    <div class="row">
                      <div class="col-3"></div>
                      <div class="col-9">
                        <button v-if="$store.state.wishlistType === 'giftlist' && this.$v.$invalid" type="submit"
                          data-bs-toggle="modal" data-bs-target="#paymentModal" class="btn btn-block btn-xl mt-5"
                          style="text-align:center; background-color:orange;color:white;">
                          Make Card Payment
                        </button>
                        <button v-else type="submit" class="btn btn-block btn-xl mt-5 goToPayment"
                          data-bs-toggle="modal" data-bs-target="#paymentModal">
                          Make Card Payment
                        </button>
                        <!-- Only displays in PROD Env -->
                        <div v-if="!$v.$invalid && intAddress !== 'yes'" class="flex justify-content-center mt-3 w-100">
                          <ApplePay :formData="formData" @on-submit="applePaySubmit($event)" />
                        </div>
                        <!-- Only displays in PROD Env -->
                        <div v-if="!$v.$invalid && intAddress !== 'yes'" class="flex justify-content-center mt-3 w-100">
                          <GooglePay :formData="formData" @on-submit="googlePaySubmit($event)" />
                        </div>

                        <b-alert v-if="formInvalid" class="mt-2" style="text-align:center" variant="danger" show>Please
                          complete all required fields</b-alert>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-form>
          </div>
        </section>
      </b-col>
    </section>

    <section v-else-if="paymentSuccess" class="row mt-3" style="margin-left:1px;margin-right:1px;">
      <b-col sm="12">
        <section class="row" style="margin-left:1px;margin-right:1px;">
          <div class="col-md-12 col-md-offset-1">
            <section class="row form-group m-t-md">
              <div>
                <b-alert variant="success" show class="text-center">
                  Thank you for your contribution. An email has been sent to
                  your inbox. Your reference number is:
                  <strong>{{ messageNumber }}</strong>.
                </b-alert>
              </div>
            </section>


          </div>
        </section>
      </b-col>
    </section>

    <b-modal id="paymentModal" class="modal" ref="paymentModal" hide-header-close tabindex="-1"
      aria-labelledby="paymentModal" aria-hidden="true" role="dialog" title="Contribution Payment">
      <div class="modal-body">
        <section v-if="barclaysError | !isConnected" class="rd-flex justify-content-center ms-5 mb-3">
          <div class="col-10 col-md-10 alert alert-warning ms-5">
            <p>
              Unfortunately we have not been able to process your request.
              <br />
              Your Debit/Credit card has not been charged.
              <br />
              If the issue persists please call Trailfinders Wishlist
              department on
              <strong>{{ $store.state.user.site_info.telno }}</strong>
            </p>
          </div>
        </section>
        <b-row v-else-if="isLoading">
          <b-col cols="6"></b-col>
          <b-col cols="1">
            <b-spinner label="Loading..."></b-spinner>
          </b-col>
        </b-row>
        <div v-if="formInvalid" class="d-flex justify-content-center mb-0 text-center">
          <b-alert class="mt-2" style="text-align:center" variant="danger" show>Please complete all required
            fields</b-alert>
        </div>
        <div v-else class="col-xs-12 col-md-12">
          <section v-if="paymentError" class="row form-group m-t-md">
            <div>
              <b-alert variant="danger" show class="text-center">
                Unfortunately we have not been able to process your request.
                <br />
                Your Debit/Credit card has not been charged.
                <br />
                <br />
                If the issue persists please call our Trailfinders Wishlist
                Team on
                <a :href="`tel:${$store.state.user.site_info.telno}`" data-ga4-label="giftlist_admin" data-ga4-category="text_link">{{
                  $store.state.user.site_info.telno
                }}</a>
              </b-alert>
            </div>
          </section>
          <section v-if="sfError" class="row form-group m-t-md">
            <div>
              <b-alert variant="danger" show class="text-center">
                Sorry there seems to have been an error, please call our
                Wishlist Team on
                <a :href="`tel:${$store.state.user.site_info.telno}`" data-ga4-label="giftlist_admin" data-ga4-category="text_link">{{
                  $store.state.user.site_info.telno
                }}</a>
                <span v-if="messageNumber !== ''">
                  and keep hold of your refernce number
                  {{ messageNumber }}</span>
              </b-alert>
            </div>
          </section>
          <section v-if="paymentSuccess" class="row form-group m-t-md">
            <div>
              <b-alert variant="success" show class="text-center">
                Thank you for your contribution. An email has been sent to
                your inbox. Your reference number is:
                <strong>{{ messageNumber }}</strong>.
              </b-alert>
            </div>
          </section>
          <iframe v-else id="payment-frame" :src="barclaysUrl"></iframe>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" size="sm" class="float-right" @click="show = false">
            Close
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { getPostcode } from "../../services/api";
import { validationMixin } from "vuelidate";
import Autoaddress from "@autoaddress.ie/autoaddress-vue/src/Autoaddress";
import { countryCodes } from "../../assets/countryCodes";
import GooglePay from "../GooglePay"
import ApplePay from "../ApplePay"
import {
  required,
  email,
  minLength,
  requiredIf,
  numeric
} from "vuelidate/lib/validators";
export default {
  sockets: {
    connect: function () {
      this.isConnected = true;
    },
    begin: function () { },
    beginResponse: function (resp) {
      if (resp && resp.paymentRedirectUrl) {
        this.barclaysStage1 = false;
        this.barclaysStage2 = true;
        this.barclaysUrl = resp.paymentRedirectUrl;
        if (this.barclaysUrl !== "") {
          this.barclaysError = false;
          this.isLoading = false;
        }
      } else {
        this.barclaysError = true;
        this.isLoading = false;
      }
    },
    finished: async function (finishedResponse) {
      if (
        finishedResponse &&
        (finishedResponse.result.status.toUpperCase() === 'OK' || finishedResponse.success === true) &&
        finishedResponse.result
      ) {
        this.paymentSuccess = true;
        this.messageNumber = finishedResponse.result.giftbookno;
        this.barclaysStage1 = false;
        this.barclaysStage2 = false;
        this.paymentSuccess = true;
        this.isLoading = false;

      } else if (
        finishedResponse &&
        finishedResponse.success === true &&
        !finishedResponse.result
      ) {
        this.barclaysStage1 = false;
        this.barclaysStage2 = false;
        this.sfError = true;
        if (finishedResponse.result.giftbookno) {
          this.messageNumber = finishedResponse.result.giftbookno;
        }
        this.isLoading = false;
      } else if (finishedResponse && finishedResponse.error) {
        this.barclaysStage1 = false;
        this.barclaysStage2 = false;
        this.paymentError = true;
        this.isLoading = false;
      } else {
        this.barclaysError = true;
        this.isLoading = false;
      }
    }
  },
  mixins: [validationMixin],
  components: {
    Autoaddress,
    GooglePay,
    ApplePay
  },
  props: {
    screenWidth: Number,
    tabIndex: Number
  },
  data() {
    return {
      meta: {
        loaded: true
      },
      barclaysModalError: false,
      barclaysStage1: true,
      paymentModal: false,
      barclaysError: false,
      barclaysStage2: false,
      sfError: false,
      isConnected: true,
      barclaysUrl: "",
      formInvalid: false,
      isLoading: true,
      paymentSuccess: false,
      paymentError: false,
      tfMagazines: null,
      countryCodes: [],
      countryCode: null,
      intAddress: "",
      tfEmails: null,
      isIe: false,
      data: {},
      name: "",
      number: null,
      email: null,
      amount: null,
      message: null,
      isAddressUk: "",
      isAddressIe: "",
      addressLine1: "",
      addressLine2: "",
      addressLine3: "",
      postCode: "",
      postcodeSearch: "",
      eircode: "",
      postcodeDropdown: false,
      postcodeResult: [],
      addressFound: false,
      title: null,
      firstname: "",
      surname: "",
      isIE: false,
      ref: ".com",
      GENERAL_CONFIG: {},
      currency: "GBP",
      messageNumber: "",
      titleOptions: [
        { text: "Select Title", value: null },
        "Mrs",
        "Miss",
        "Ms",
        "Mr",
        "Dr",
        "Other"
      ],
      site: "UK"
    };
  },
  validations: {
    title: {
      required: required
    },
    firstname: {
      required: required
    },
    surname: {
      required: required
    },
    number: {
      required: required
    },
    email: {
      required: required,
      email: email,
      minLength: minLength(3)
    },
    amount: {
      required: required,
      numeric: numeric
    },
    message: {
      required: required
    },
    countryCode: {
      required: requiredIf(function () {
        return this.intAddress === "yes";
      })
    },
    postCode: {
      required: requiredIf(function () {
        return !this.isIe;
      })
    },
    eircode: {
      required: requiredIf(function () {
        return this.isIe;
      })
    },
    addressLine1: {
      required: required,
      minLength: minLength(3)
    },
    addressLine2: {
      required: required,
      minLength: minLength(2)
    }
  },
  computed: {
    contributionClosed() {
      let currentDate = new Date();
      let closing = new Date(this.$store.state.user.contributions_closing.iso);
      let shouldShow = false;

      closing.setHours(23, 59, 59, 0);

      if (currentDate.getTime() > closing.getTime()) {
        shouldShow = false;
      } else {
        shouldShow = true;
      }

      if (
        (this.$store.state.user.contributions_limit !== 0 &&
          this.$store.state.user.contributions_total >
          this.$store.state.user.contributions_limit) || this.$store.state.user.reference === "5BLU24"
      ) {
        shouldShow = false;
      }

      return shouldShow;
    },
    formData() {
      return this.buildWishlistData()
    }
  },
  methods: {
    generateUUID: function () {
      var d = new Date().getTime();
      var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (d + Math.random() * 16) % 16 | 0;
          d = Math.floor(d / 16);
          return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
        }
      );
      return uuid;
    },
    touchField: function (field) {
      if (field && typeof field.touch === "function") {
        field.touch();
      }
    },
    validateState(name) {
      const { $dirty, $error } = this.$v[name];
      return $dirty ? !$error : null;
    },
    foundAddress(addressInfo) {
      if (addressInfo.postalAddress) {
        if (addressInfo.postalAddress[0]) {
          this.addressLine1 = addressInfo.postalAddress[0];
        }
        if (addressInfo.postalAddress[1]) {
          this.addressLine2 = addressInfo.postalAddress[1];
        }
        if (addressInfo.postalAddress[2]) {
          this.addressLine3 = addressInfo.postalAddress[2] || "";
        }
        if (addressInfo.postcode) {
          this.postCode = addressInfo.postcode.toUpperCase();
        }
        if (this.isIe) {
          this.eircode = addressInfo.postcode.toUpperCase();
        }
        this.addressFound = true;
      } else {
        this.addressFound = true;
      }
    },
    handleSelection(data) {
      // Select data and split into lines
      let address = data.split(",");
      // Populate input fields
      this.addressLine1 = address[0].trim();
      this.addressLine2 = address[1];
      this.addressLine3 = address[2] || "";
      // this.contactForm.addressLine4 = address[3]
      this.postCode = this.postcodeSearch.toUpperCase();
      // Close dropdown
      this.postcodeDropdown = false;
      // Set postcode finder input back to empty
      this.postcodeSearch = "";
    },
    postcodeLookup() {
      getPostcode(this.postcodeSearch).then(response => {
        if (response.data.count) {
          this.postcodeDropdown = true;
          this.postcodeResult = response.data.results;
          this.addressFound = true;
        } else {
          this.addressFound = true;
          this.postcodeResult = [];
          this.postcodeDropdown = false;
        }
      });
    },
    googlePaySubmit(googleData) {
      this.sfError = false;
      this.formInvalid = false;
      if (!this.$v.$invalid) {
        if (
          googleData &&
          googleData.detail.paymentMethodData.tokenizationData.token
        ) {
          this.data.wishlistData.card.payment_type = "GooglePay";
          this.data.payType = "GooglePay"
          this.data.sessionToken =
            googleData.detail.paymentMethodData.tokenizationData.token;
        }
        if (
          googleData &&
          !googleData.detail.paymentMethodData.tokenizationData.token
        ) {
          this.paymentError = true
        }
        this.isLoading = true
        this.$refs['paymentModal'].show()
        this.$socket.emit("beginWishlist", this.data);
      } else {
        this.isLoading = false;
        this.formInvalid = true;
      }
    },
    async applePaySubmit(appleData) {
      this.sfError = false;
      this.formInvalid = false;
      if (!this.$v.$invalid) {
        if (appleData) {
          this.data.wishlistData.card.payment_type = "ApplePay";
          this.data.payType = "ApplePay";
          this.token = JSON.stringify(appleData)
          this.data.sessionToken = JSON.stringify(appleData)
        }
        if (
          !appleData
        ) {
          this.paymentError = true
        }

        this.isLoading = true
        this.$refs['paymentModal'].show()
        this.$socket.emit("beginWishlist", this.data);
      } else {
        this.isLoading = false;
        this.formInvalid = true;
      }
    },
    async onSubmit(e) {
      this.isLoading = true;
      this.sfError = false;
      this.formInvalid = false;
      e.preventDefault();
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$refs['paymentModal'].show()
        let dataObj = await this.buildWishlistData();
        this.$socket.emit("beginWishlist", dataObj);
      } else {
        this.isLoading = false;
        this.formInvalid = true;
      }
    },
    isNumber(e) {
      e = e ? e : window.event;
      let charCode = e.which ? e.which : e.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        e.preventDefault();
      } else {
        return true;
      }
    },
    buildWishlistData() {
      if (this.countryCode !== null && this.intAddress == "yes") {
        this.data.countryCode = this.countryCode;
      } else if (this.site === "IE") {
        this.data.countryCode = "IRL";
      } else {
        this.data.countryCode = "GBR";
      }
      // Google/Apple Pay Token
      this.data.sessionToken = ''
      this.data.country = this.site;
      this.data.site = "TF";
      this.data.name = `${this.firstname.normalize("NFD").replace(/\p{Diacritic}/gu, "")} ${this.surname.normalize("NFD").replace(/\p{Diacritic}/gu, "")}`;
      this.data.title = this.title;
      this.data.firstname = this.firstname.normalize("NFD").replace(/\p{Diacritic}/gu, "");
      this.data.surname = this.surname.normalize("NFD").replace(/\p{Diacritic}/gu, "");
      this.data.sessionToken = "";
      this.data.billingAddressLine1 = this.addressLine1;
      this.data.billingAddressLine2 = this.addressLine2;
      this.data.billingAddressLine3 = this.addressLine3 || "";
      this.data.billingAddressPostcode = this.postCode ? this.postCode.replace(/\s/g, "") : null
      if (this.isIe) {
        this.data.billingAddressPostcode = this.eircode;
      }
      this.data.currencyCode = this.currency;
      this.data.purchaseAmount = parseInt(this.amount);
      // Superfacts Data
      this.data.logname = "temp";
      this.data.email = this.email;
      this.data.phone = this.number;
      this.data.purchaseDescription = "WISHLIST";
      this.data.staffid = "001";
      this.data.bookReference = this.$store.state.user.reference;
      this.data.bookSurname = this.$store.state.user.surname;
      this.data.date = this.$store.state.user.wedding_day.date;
      // EIRCODE
      this.data.eircode = "";
      if (this.isIe) {
        this.data.eircode = this.eircode;
        this.data.billingAddressPostcode = 'IRELAND'
      }
      this.data.wishlistData = {};
      // Remove emojis from string
      this.data.message = this.message ? this.message.replace(
        /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g,
        ""
      ) : null
      this.data.wishlistData.contribution = {
        amount: this.amount,
        name: `${this.firstname.normalize("NFD").replace(/\p{Diacritic}/gu, "")} ${this.surname.normalize("NFD").replace(/\p{Diacritic}/gu, "")}`,
        message: this.message,
        email: this.email,
        staffid: "001",
        number: this.number,
        address_line_1: this.addressLine1,
        address_line_2: this.addressLine2,
        address_line_3: this.addressLine3 || "",
        currencyCode: this.currency,
        postcode: this.postCode ? this.postCode.replace(/\s/g, "") : null,
        uid: this.generateUUID(),
        mailing_optout: false
      };
      // EIRCODE
      this.data.wishlistData.contribution.eircode = "";
      if (this.isIe) {
        this.data.wishlistData.contribution.eircode = this.eircode;
        this.data.wishlistData.contribution.postcode = this.eircode;
      }
      this.data.wishlistData.wishlist_type = this.$store.state.wishlistType;
      this.data.wishlistData["_id"] = this.$store.state.user["_id"];
      this.data.wishlistData.uuid = this.generateUUID();
      this.data.wishlistData.mailing_optin = false;
      this.data.wishlistData.amount = parseInt(this.amount);
      this.data.wishlistData.card = {
        payment_type: "CRD",
        title: this.title,
        first_name: this.firstname.normalize("NFD").replace(/\p{Diacritic}/gu, ""),
        surname: this.surname.normalize("NFD").replace(/\p{Diacritic}/gu, ""),
        source: "Website",
        ccpayment: parseInt(this.amount),
        cardvalid: true
      };
      return this.data;
    }
  },
  mounted() {
    this.meta.loaded = true;
    this.isIe = false;
    this.ref = ".com";
    this.GENERAL_CONFIG.CURRENCY = "£";
    this.GENERAL_CONFIG.TELEPHONE = "020 7408 9003";
    this.currency = "GBP";
    this.site = "UK";
    this.countryCodes = countryCodes;
    if (window.location.toString().indexOf("trailfinders.ie") > 0) {
      this.isIe = true;
      this.ref = ".ie";
      this.GENERAL_CONFIG.CURRENCY = "€";
      this.GENERAL_CONFIG.TELEPHONE = "01 702 9102";
      this.currency = "EUR";
      this.site = "IE";
    }
  }
};
</script>
<style>
#payment-frame {
  border: 0px;
  margin: auto;
  width: 100%;
  height: 600px;
}

#exampleModalLongTitle .spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: text-bottom;
  border: 0.25em solid;
  border-right: 0.25em solid transparent;
  border-radius: 50%;
  -webkit-animation: spinner-border 0.75s linear infinite;
  animation: spinner-border 0.75s linear infinite;
}

#exampleModalLongTitle .sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

#exampleModalLongTitle .spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: text-bottom;
  border: 0.25em solid;
  border-right: 0.25em solid transparent;
  border-radius: 50%;
  -webkit-animation: spinner-border 0.75s linear infinite;
  animation: spinner-border 0.75s linear infinite;
}

#exampleModalLongTitle .col-6 {
  flex: 0 0 50%;
  max-width: 50%;
}

#exampleModalLongTitle .col-1 {
  flex: 0 0 8.333333%;
  max-width: 8.333333%;
}

.autoaddress-control {
  max-width: 650px;
  margin: 10px 0;
  font-size: 15px;
  color: #777c89;
  font-family: inherit;
  position: relative;
  line-height: normal;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
}

.autoaddress-control>.autoaddress-text-box {
  outline: 0;
  border: 0;
  border: 1px solid #dedede;
  border-radius: 3px;
  color: #999999;
  line-height: normal;
  line-height: 52px\9;
  height: 55px;
  width: 80%;
  box-sizing: border-box;
  background: #fff;
  font-size: 16px;
  color: #666;
  margin: 0;
  padding: 0 10px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  float: left;
}

.autoaddress-control>.autoaddress-button {
  background-color: #9cc06e;
  border: 1px solid #9cc06e;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  text-decoration: none;
  font-size: 20px;
  font-weight: 400;
  line-height: normal;
  height: 55px;
  text-align: center;
  vertical-align: middle;
  border-radius: 4px;
  width: 20%;
  margin: 0;
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  clear: right;
  position: relative;
  box-sizing: border-box;
}

.autoaddress-control .autoaddress-autocomplete {
  border: solid 1px #ccc;
  position: absolute;
  z-index: 1;
  width: 99.8%;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  box-shadow: 0 6px 12px rgb(0 0 0 / 30%);
}

.custom-control-label {
  display: inline;
}

.show-modal {
  opacity: 1;
  visibility: visible;
  transform: scale(1.0);
  transition: visibility 0s linear 0s, opacity 0.25s 0s, transform 0.25s;
}
</style>
